/**
 * Блокировка прокрутки страницы при открытых модалках (AS-2000).
 * Счётчик вложенности — RSD поверх карточки ЛП и т.п.
 */

let lockCount = 0
let savedScrollY = 0

export function lockPageScroll() {
  lockCount += 1
  if (lockCount > 1) {
    return
  }
  savedScrollY = window.scrollY || window.pageYOffset || 0
  document.documentElement.classList.add('modal-open')
  document.body.classList.add('modal-open')
  document.body.style.top = `-${savedScrollY}px`
  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.width = '100%'
  document.body.style.left = '0'
  document.body.style.right = '0'
}

export function unlockPageScroll() {
  lockCount = Math.max(0, lockCount - 1)
  if (lockCount > 0) {
    return
  }
  document.documentElement.classList.remove('modal-open')
  document.body.classList.remove('modal-open')
  document.body.style.top = ''
  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.width = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.paddingRight = ''
  window.scrollTo(0, savedScrollY || 0)
}

/** Сброс при закрытии всего стека (на случай рассинхрона). */
export function resetPageScrollLock() {
  // Confirm без lockPageScroll тоже вызывает сброс. scrollTo(0) уводил карточку в начало.
  const shouldRestore = lockCount > 0
  lockCount = 0
  document.documentElement.classList.remove('modal-open')
  document.body.classList.remove('modal-open')
  document.body.style.top = ''
  document.body.style.overflow = ''
  document.body.style.position = ''
  document.body.style.width = ''
  document.body.style.left = ''
  document.body.style.right = ''
  document.body.style.paddingRight = ''
  if (shouldRestore) {
    window.scrollTo(0, savedScrollY || 0)
  }
}
